export default __webpack_public_path__ + "static/media/timer.cc46b2ca.png";